export enum EventActions {
    EXTERNAL_LINK_CLICK = 'External_link_click',
    MAIL_TO_LINK_CLICK = 'Mail_to_link_click',
    QUESTION_EXPAND = 'Question_expand',
  }
